// Clients for the Phase 4 user endpoints: answer feedback and experience
// notes (contributions). Both send the Supabase JWT; the server verifies it
// and derives the user id from the token.
import { supabase } from '../lib/supabaseClient';

async function authedPost(path, body) {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) throw new Error('Please log in first.');

  const res = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  let json = null;
  try {
    json = await res.json();
  } catch {
    // non-JSON body — handled by the generic error below
  }
  if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
  return json;
}

// rating: 'up' | 'down' | 'wrong'. Safe to call again for the same answer —
// the server updates the existing row instead of duplicating it.
export function sendFeedback({ queryLogId, rating, comment }) {
  return authedPost('/api/feedback', {
    query_log_id: queryLogId,
    rating,
    comment: comment || undefined,
  });
}

// share=true (default) → saved privately AND queued for community review
// (+20 messages if approved); share=false → private notebook only.
export function submitContribution({ equipmentPath, content, share = true }) {
  return authedPost('/api/contributions', {
    equipment_path: equipmentPath,
    content,
    share,
  });
}
